import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, TrashIcon } from '@heroicons/react/24/outline';

const DataDeletion = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aqui você implementaria a lógica de solicitação de exclusão
    console.log('Solicitação de exclusão para:', email);
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container-custom py-12">
        <Link to="/" className="inline-flex items-center text-medical-600 hover:text-medical-700 mb-8">
          <HomeIcon className="w-5 h-5 mr-2" />
          Voltar para Home
        </Link>

        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 max-w-4xl mx-auto">
          <div className="flex items-center space-x-3 mb-6">
            <TrashIcon className="w-10 h-10 text-red-600" />
            <h1 className="text-4xl font-bold text-gray-800">Data Deletion Request</h1>
          </div>
          
          <p className="text-gray-600 mb-8">
            Conforme a LGPD (Lei Geral de Proteção de Dados), você tem o direito de solicitar
            a exclusão de seus dados pessoais de nossa plataforma.
          </p>

          {!submitted ? (
            <div>
              <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800">Como Funciona</h2>
              <div className="prose prose-lg max-w-none mb-8">
                <ol className="list-decimal list-inside text-gray-600 space-y-3">
                  <li>Preencha o formulário abaixo com o e-mail da sua conta</li>
                  <li>Você receberá um e-mail de confirmação em até 24 horas</li>
                  <li>Responda o e-mail confirmando a solicitação</li>
                  <li>Seus dados serão excluídos em até 30 dias</li>
                </ol>

                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 my-6">
                  <p className="text-yellow-800 font-semibold">⚠️ Atenção</p>
                  <p className="text-yellow-700 text-sm mt-2">
                    A exclusão é permanente e irreversível. Todos os dados associados à sua conta,
                    incluindo exames e laudos, serão removidos.
                  </p>
                </div>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    E-mail da Conta
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-medical-500 focus:border-transparent"
                    placeholder="seu.email@exemplo.com"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-red-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-red-700 transition-colors"
                >
                  Solicitar Exclusão de Dados
                </button>
              </form>
            </div>
          ) : (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-health-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-health-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Solicitação Enviada!</h3>
              <p className="text-gray-600 mb-8">
                Você receberá um e-mail de confirmação em <strong>{email}</strong> nas próximas 24 horas.
              </p>
              <Link to="/" className="btn-primary inline-block">
                Voltar para Home
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DataDeletion;
